import { Link } from 'components/link';
import { PageHeader } from 'components/page-header';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from 'utils/page-title';
import { EnergyLinkAccessCheck } from './energy-link-access-check';

const EnergyLinkPage = () => {
  return (
    <EnergyLinkAccessCheck>
      <Helmet>
        <title>{pageTitle('Energy Link')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[['/energy_link', 'Energy Link']]}
        title="Energy Link"
        actions={null}
      />
      <div style={{ margin: '2rem' }}>
        <Link to="/energy_link/accounts">Accounts</Link>
      </div>
    </EnergyLinkAccessCheck>
  );
};

export { EnergyLinkPage };
